import { z } from 'zod';
import { isAfter, startOfDay } from 'date-fns';

const durationNumberField = (fieldLabel: string, max?: number) =>
  z.preprocess(
    (val) => {
      if (val === '' || val === null || val === undefined) return 0;
      const num = Number(val);
      return isNaN(num) ? 0 : num;
    },
    max != null
      ? z
          .number({ invalid_type_error: `${fieldLabel} must be a valid number` })
          .min(0, { message: `${fieldLabel} must be 0 or greater` })
          .max(max, { message: `${fieldLabel} cannot exceed ${max}` })
      : z
          .number({ invalid_type_error: `${fieldLabel} must be a valid number` })
          .min(0, { message: `${fieldLabel} must be 0 or greater` })
  );

export const workActivityStep1Schema = z
  .object({
    activity_name: z.string().trim().min(1, 'Enter activity'),
    description: z.string().trim().min(1, 'Describe your activity'),
    activity_date: z.date({ message: 'Select date' }),
    duration_hours: durationNumberField('Hours'),
    duration_minutes: durationNumberField('Minutes', 59)
  })
  .refine((data) => !isAfter(startOfDay(data.activity_date), startOfDay(new Date())), {
    message: 'Activity date cannot be in the future',
    path: ['activity_date']
  })
  .refine((data) => data.duration_hours > 0 || data.duration_minutes > 0, {
    message: 'Enter duration',
    path: ['duration_hours']
  });

export type WorkActivityStep1FormValues = z.infer<typeof workActivityStep1Schema>;
